<template>
  <div class="userInfoWrapper info-icon mr-2 mt-1">
    <div class="position-relative">
      <i
        class="fa fa-info-circle w-100 h-100"
        style="color: #007bff;"
        aria-hidden="true"
      ></i>
    </div>
    <div class="info-card-container p-2">
      <template
        v-if="
          userInfo.username ||
            userInfo.first_name ||
            userInfo.last_name ||
            userInfo.modified_at
        "
      >
        <h6 class="userInfoTab">
          <b>Source:</b> Company Data (as of June 2019)
        </h6>
        <h6 class="userInfoTab"><b>Timeline:</b> Dec-1999 to May-2019</h6>
        <h6 class="userInfoTab" id="data_update_container">
          <b>Update By:</b>
          <span id="data_udpate_users_name"> {{ userInfo.username }}</span>
        </h6>
        <h6 class="userInfoTab m-0" id="data_update_date_container">
          <b>Update date:</b>
          <span id="data_udpate_date"> {{ userInfo.modified_at }}</span>
        </h6>
      </template>
      <template v-else>
        <p class="m-1-1" v-if="typeof userInfo === 'string'">
          {{ userInfo }}
        </p>
        <p class="m-1" v-else>
          {{ "No information found" }}
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      userInfo: "userInfo",
    }),
  },
};
</script>
<style scoped>
/*--------Source Tab-------------*/
.userInfoWrapper {
  background-color: #fff;
}
.iframe-userinfo .userInfoWrapper {
  bottom: 1px;
}
.userInfoWrapper {
  display: inline-block;
  right: 10px;
  bottom: 10px;
  z-index: 50;
}
.userInfoWrapper .info-card-container {
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 100%;
  z-index: 50;
  width: max-content;
  border: 1px solid silver;
  background-color: #fff;
  text-align: left;
}
.info-icon:hover .info-card-container {
  display: block !important;
}
.info-icon {
  width: 20px;
  height: 20px;
}
.userInfoTab {
  font-size: 11px;
  /* padding: 0px 5px 0px 5px; */
}
</style>
